import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const NeonTabsContainer = styled(Box)(({ theme }) => ({
  borderBottom: 1,
  borderColor: 'divider',
  marginBottom: theme.spacing(2),
  position: 'relative',
  '& .MuiTabs-indicator': {
    height: 3,
    backgroundColor: 'transparent',
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: '100%',
      height: '3px',
      background: `linear-gradient(90deg, ${theme.palette.primary.main}4d 0%, ${theme.palette.primary.main} 50%, ${theme.palette.primary.main}4d 100%)`,
      animation: 'glow 2s infinite',
      borderTopLeftRadius: '50px',
      borderTopRightRadius: '50px',
    }
  },
  '@keyframes glow': {
    '0%': {
      opacity: 0.4,
    },
    '50%': {
      opacity: 1,
    },
    '100%': {
      opacity: 0.4,
    }
  }
})); 